import { FunctionComponent, memo } from 'react';
import { FeedCardProps, FeedCardTeaser } from '../../../shared';

export const FeedCardAdminArticle: FunctionComponent<FeedCardProps> = memo(({ card }) => {
  return <FeedCardTeaser card={card} />;
});
